'use client'

import { CurriculumType, LangType, PaymentType } from '@server/schemas'
import { useI18n } from '@shared/config/i18n'
import { formatKrwAmount } from '@shared/utils'

import { Typography } from '@podo-app/design-system-temp'

type PriceMetaBaseProps = {
  curriculumType?: CurriculumType
  paymentType?: PaymentType
  langType?: LangType
}

export type SubscribeOriginalPriceProps = PriceMetaBaseProps & {
  originalPrice?: number
  perMonth?: boolean
}

export type SubscribeDiscountBadgeProps = PriceMetaBaseProps & {
  discountPercent?: number
  month?: number
}

const getOriginalMonthlyPrice = (props: SubscribeOriginalPriceProps): number | null => {
  const { curriculumType, paymentType, langType } = props

  if (curriculumType !== 'SMART_TALK') {
    return null
  }
  if (paymentType === 'TRIAL') {
    return 30000
  }
  if (langType === 'EN') {
    return 130000
  }
  if (langType === 'JP') {
    return 150000
  }
  return null
}

const getDiscountPercent = (props: SubscribeDiscountBadgeProps): number | null => {
  const { curriculumType, paymentType, langType, month } = props

  if (curriculumType !== 'SMART_TALK') {
    return null
  }
  if (paymentType === 'TRIAL') {
    return 99
  }
  if (langType === 'EN') {
    if (month === 1) {
      return 62
    }
    if (month === 3) {
      return 70
    }
    if (month === 6) {
      return 73
    }
  }
  if (langType === 'JP') {
    if (month === 1) {
      return 60
    }
    if (month === 3) {
      return 67
    }
    if (month === 6) {
      return 70
    }
  }
  return null
}

export const SubscribeOriginalPrice = (props: SubscribeOriginalPriceProps) => {
  const { perMonth = true } = props
  const { effectiveLocale, t } = useI18n()

  const price = props.originalPrice ?? getOriginalMonthlyPrice(props)

  if (price === null) {
    return null
  }
  return (
    <Typography className="line-through text-gray-400 !text-[14px] font-normal">
      {`${formatKrwAmount(price, effectiveLocale)}${perMonth ? t('subscribeList.ticket.perMonth') : ''}`}
    </Typography>
  )
}

export const SubscribeDiscountBadge = (props: SubscribeDiscountBadgeProps) => {
  const percent = props.discountPercent ?? getDiscountPercent(props)

  if (percent === null) {
    return null
  }
  return (
    <div className="flex h-7 px-3 items-center bg-red-light rounded-[14px]">
      <Typography className="text-[12px] text-[#FD6771] font-bold">-{percent}%</Typography>
    </div>
  )
}
